// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2lPrG","footer":"ModalCreateQualiphyProcedure_footer__2myn_","additionData":"ModalCreateQualiphyProcedure_additionData__3W3rR"};